<template>
  <div
    ref="scrollContainerRef"
    class="horizontal-scroll-container"
  >
    <slot />
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';

const scrollContainerRef = ref(null);
let isScrolling = false;
let startX;
let scrollLeft;

const setupDragScroll = () => {
  const scrollContainer = scrollContainerRef.value;
  if (!scrollContainer) { return; }

  scrollContainer.addEventListener('mousedown', e => {
    isScrolling = true;
    startX = e.pageX - scrollContainer.offsetLeft;
    scrollLeft = scrollContainer.scrollLeft;
    scrollContainer.style.cursor = 'grabbing';
  });

  scrollContainer.addEventListener('mouseleave', () => {
    isScrolling = false;
    scrollContainer.style.cursor = 'grab';
  });

  scrollContainer.addEventListener('mouseup', () => {
    isScrolling = false;
    scrollContainer.style.cursor = 'grab';
  });

  scrollContainer.addEventListener('mousemove', e => {
    if (!isScrolling) { return; }
    e.preventDefault();
    const x = e.pageX - scrollContainer.offsetLeft;
    const walk = (x - startX) * 2; // Scroll speed multiplier
    scrollContainer.scrollLeft = scrollLeft - walk;
  });
};

onMounted(() => {
  setupDragScroll();
});
</script>

<style lang="scss" scoped>
.horizontal-scroll-container {
  display: flex;
  overflow-x: auto;
  padding: 10px 5%;
  gap: 15px;
  -webkit-overflow-scrolling: touch; /* For smooth scrolling on iOS */
  scrollbar-width: none; /* Hide scrollbar for Firefox */
  &::-webkit-scrollbar {
    display: none; /* Hide scrollbar for Chrome/Safari */
  }
  margin: 0 auto;
  white-space: nowrap;
  cursor: grab; /* Show grab cursor to indicate draggable */
  position: relative;
  z-index: 1;
}
</style>
